<template>
  <BaseFormFieldLayout
    :id="id"
    :label="label"
    :note="note"
    :error-message="errorMessage"
    :field-class="fieldClass"
    :label-class="labelClass"
  >
    <ASelect
      :id="id"
      v-model:value="model"
      v-bind="$attrs"
      :class="{ 'is-invalid': errorMessage, 'w-100': !$attrs.class }"
      option-filter-prop="label"
      option-label-prop="label"
      :size="size"
      @change="$attrs.onChange"
      @paste="$attrs.onPaste"
    >
      <template v-if="!!slots.option" #option="slotProps">
        <slot name="option" v-bind="slotProps" />
      </template>
      <template v-if="!!slots.tagRender" #tagRender="slotProps">
        <slot name="tagRender" v-bind="slotProps" />
      </template>
      <slot />
    </ASelect>
  </BaseFormFieldLayout>
</template>

<script lang="ts" setup>
import { asyncComponentWrapper } from '@/composables/useReloadModal'
import { useSlots, PropType } from 'vue'
const ASelect = asyncComponentWrapper(() => import('ant-design-vue/es/select'))

const model = defineModel<string | string[] | number | number[] | null>()

const slots = useSlots()

defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  note: {
    type: String,
    default: '',
  },
  errorMessage: {
    type: String,
    default: '',
  },
  fieldClass: {
    type: String,
    default: '',
  },
  labelClass: {
    type: String,
    default: '',
  },
  size: {
    type: String as PropType<'small' | 'large'>,
    default: 'large',
  },
})
</script>
